import { parsePhoneNumberFromString } from 'libphonenumber-js'


const formatPhoneNumber = data => {
    if (!data?.countryCode || !data?.number) return ''

    const phoneNumber = parsePhoneNumberFromString(data.countryCode + data.number)

    if (!phoneNumber || !phoneNumber.isValid()) return ''

    const formattedNumber = phoneNumber.formatInternational()
    const extensionPart = data.extension ? ` x${data.extension}` : ''

    return `${formattedNumber}${extensionPart}`
}

const hiddenFormatPhoneNumber = phoneNumber => {
    if (!phoneNumber) return ''
    return `xxxxxx${phoneNumber.slice(-4)}`

}

const formatPhoneNumberWithSymbol = (data, sym ='-') => {
    if (!data?.number) return ''
    
    // Remove all non-numeric characters
    let cleaned = data.number.toString().replace(/\D/g, '')
    
    // Check if it's a 10-digit number
    if (cleaned.length === 10) {
        cleaned = `${cleaned.slice(0, 3)}${sym}${cleaned.slice(3, 6)}${sym}${cleaned.slice(6, 10)}`
    }
    const extensionPart = data.extension ? ` x${data.extension}` : ''
    
    // Return original if it doesn't match expected format
    return `${data?.countryCode} ${cleaned}${extensionPart}`
}

export { formatPhoneNumber, hiddenFormatPhoneNumber, formatPhoneNumberWithSymbol }
